export default "assets/images/icons/point-a2ddb656.svg";